import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');
export const AUTH_API_URL = new InjectionToken<string>('AUTH_API_URL');
